module.exports = __webpack_public_path__ + "img/capac_utra_equaphon_2014.82d7205f.jpg";